module.exports = __webpack_public_path__ + "img/2024_1.8197c69d.webp";